import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Added useLocation import
import Header from '../Header'; // Adjusted path
import Footer from '../Footer/Footer'; // Adjusted path
import TelegramPopup from '../../Common/TelegramPopup/TelegramPopup'; // Adjusted path
import TokenCard from './TokenCard'; // Added import for TokenCard
import './TreasuryPage.scss';

const ASTROLESCENT_API_URL = 'https://api.astrolescent.com/partner/reddicks/prices';

const formatCurrency = (value) => {
  if (typeof value !== 'number' || isNaN(value)) {
    return '$0.00';
  }
  return `$${value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Content from TokenHoldings.js
const tokenIconUrls = {
  REDDICKS: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://blue-causal-gorilla-548.mypinata.cloud/ipfs/bafybeihxlt47xir73kc7ohfzs26ypls56on6jgcz4gnhzhrd7w34aqvk74',
  MXRD: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://ih0.redbubble.net/avatar.9379984.140x140.jpg',
  CHUG: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://amaranth-tricky-crayfish-837.mypinata.cloud/ipfs/QmRdh16RZJ6etGBmfzmR4ScD7riC2k1S8By8RRq8vo9oTy',
  GOD: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://gateway.pinata.cloud/ipfs/bafybeigtosslrx4fe6svdvphaefhbcn7zxq6dj5wwrcnq3shkwzwbb3gq4',
  EARLY: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://arweave.net/uXCQ9YVGkEijn7PS2wdkXqwkU_YrdgpNtQPH2Y1-Qcs',
  DELIVER: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://arweave.net/EKJ6radHoK_j9yBjqkyBmNgo62ohmJIMGP2jyoYajB4',
  'RUN FLY': 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://www.runfly.today/RUN_FLY_001.png',
  FLOOP: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://assets.caviarnine.com/tokens/floop_babylon.png',
  HUG: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://tokens.defiplaza.net/cdn-cgi/imagedelivery/QTzOBjs3mHq3EhZxDosDSw/58e0fd94-7e39-4043-4307-6b8142991a00/token',
  WOWO: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://stakesafe.net/wowo/wowo.jpg',
  GREAT: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://raw.githubusercontent.com/makeradixgreat/great-token-assets/refs/heads/main/great-token-circle.png',
  XRD: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://assets.radixdlt.com/icons/icon-xrd-32x32.png',
  DFP2: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://radix.defiplaza.net/assets/img/babylon/defiplaza-icon.png',
  MOX: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://moxstudio.net/token.png', // Placeholder
  FOMO: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://bafybeihe5gthaqfkqx4ma4mht4qkzn4l6gdpznujwweng5iq6w4rplzygq.ipfs.w3s.link/Fomo%20no%20cig.jpg', // Placeholder
  CVX: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://firebasestorage.googleapis.com/v0/b/radx-meme-storage/o/mainnet%2FiconUrls%2F2eTbjF81BKTUYYfZheZyPK?alt=media', // Placeholder
  ASTRL: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://astrolescent.com/assets/img/tokens/astrl.png', // Placeholder
  SRG: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://surge.trade/images/surge_token.png', // Placeholder
  HIT: 'https://ociswap.com/cdn-cgi/image/width=180,format=auto/https://i.imgur.com/yC1bLLt.png', // Placeholder
};

const parseAmount = (amountStr) => {
  if (typeof amountStr !== 'string') return 0;
  const cleanedStr = amountStr.replace(/,/g, '');
  const multiplier = cleanedStr.toUpperCase().endsWith('B') ? 1e9 :
                     cleanedStr.toUpperCase().endsWith('M') ? 1e6 : 1;
  const numericPart = parseFloat(cleanedStr.replace(/[BM]$/i, ''));
  return isNaN(numericPart) ? 0 : numericPart * multiplier;
};

const rawTokenHoldingsData = [
  { name: 'Reddicks', symbol: 'REDDICKS', amount: '84,098,524', iconUrl: tokenIconUrls.REDDICKS, resourceAddress: 'resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp' },
  { name: 'DefiPlaza', symbol: 'DFP2', amount: '452,300', iconUrl: tokenIconUrls.DFP2, resourceAddress: 'resource_rdx1t5ywq4c6nd2lxkemkv4uzt8v7x7smjcguzq5sgafwtasa6luq7fclq' },
  { name: 'Chug', symbol: 'CHUG', amount: '100.90B', iconUrl: tokenIconUrls.CHUG, resourceAddress: 'resource_rdx1tkaal53azemtfax0es4g6xfy9mpj2x683hh6fey7gm4lcj53u2h2lx' },
  { name: 'GodFather', symbol: 'GOD', amount: '106.877M', iconUrl: tokenIconUrls.GOD, resourceAddress: 'resource_rdx1t48nlyuqh3pyy7xhrdud7gag398sejyxnp8q9mu3hzp8dur4mefnta' },
  { name: 'Early', symbol: 'EARLY', amount: '5.00M', iconUrl: tokenIconUrls.EARLY, resourceAddress: 'resource_rdx1t5xv44c0u99z096q00mv74emwmxwjw26m98lwlzq6ddlpe9f5cuc7s' },
  { name: 'Deliver', symbol: 'DELIVER', amount: '42M', iconUrl: tokenIconUrls.DELIVER, resourceAddress: 'resource_rdx1t466mhd2l2jmmzxr8cg3mkwjqhs7zmjgtder2utnh0ue5msxrhyk3t' },
  { name: 'RUN.FLY', symbol: 'RUN FLY', amount: '295.68M', iconUrl: tokenIconUrls['RUN FLY'], resourceAddress: 'resource_rdx1t5uyf7s9rpde7pezhthsuygl0sk3gj0e09zzsvsmga69zxdd8y4lvq' },
  { name: 'Floop', symbol: 'FLOOP', amount: '1.990', iconUrl: tokenIconUrls.FLOOP, resourceAddress: 'resource_rdx1t5pyvlaas0ljxy0wytm5gvyamyv896m69njqdmm2stukr3xexc2up9' },
  { name: 'Wowo', symbol: 'WOWO', amount: '19.709M', iconUrl: tokenIconUrls.WOWO, resourceAddress: 'resource_rdx1t4kc5ljyrwlxvg54s6gnctt7nwwgx89h9r2gvrpm369s23yhzyyzlx' },
  { name: 'Great Labs', symbol: 'GREAT', amount: '40M', iconUrl: tokenIconUrls.GREAT, resourceAddress: 'resource_rdx1t4mthq86ck3tc05eqwsu6538m2a5nv0wc40ysmpk4fp6nwra80glpw' },
  { name: 'XRD', symbol: 'XRD', amount: '88,663', iconUrl: tokenIconUrls.XRD, resourceAddress: 'resource_rdx1tknxxxxxxxxxradxrdxxxxxxxxx009923554798xxxxxxxxxradxrd' },
  { name: 'Monstas', symbol: 'MXRD', amount: '24.057M', iconUrl: tokenIconUrls.MXRD, resourceAddress: 'resource_rdx1th0pjp7s7fesstuj2hcggtxphzw3wc06qx5zrx0c6lsg0xalyt0nn0' },
  { name: 'MOX', symbol: 'MOX', amount: '145,000', iconUrl: tokenIconUrls.MOX, resourceAddress: 'resource_rdx1thmjcqjnlfm56v7k5g2szfrc44jn22x8tjh7xyczjpswmsnasjl5l9' },
  { name: 'FOMO', symbol: 'FOMO', amount: '120,000', iconUrl: tokenIconUrls.FOMO, resourceAddress: 'resource_rdx1t5l954908vmg465pkj7j37z0fn4j33cdjt2g6czavjde406y4uxdy9' },
  { name: 'CVX', symbol: 'CVX', amount: '12,000', iconUrl: tokenIconUrls.CVX, resourceAddress: 'resource_rdx1th04p2c55884yytgj0e8nq79ze9wjnvu4rpg9d7nh3t698cxdt0cr9' },
  { name: 'ASTRL', symbol: 'ASTRL', amount: '20,000', iconUrl: tokenIconUrls.ASTRL, resourceAddress: 'resource_rdx1t4tjx4g3qzd98nayqxm7qdpj0a0u8ns6a0jrchq49dyfevgh6u0gj3' },
  { name: 'SRG', symbol: 'SRG', amount: '130,000', iconUrl: tokenIconUrls.SRG, resourceAddress: 'resource_rdx1tka3kqqkjxcpddvcx0u300qt66z3tlzv7swqx9rklp60m5yqry6yzk' },
  { name: 'HIT', symbol: 'HIT', amount: '15B', iconUrl: tokenIconUrls.HIT, resourceAddress: 'resource_rdx1t4v2jke9xkcrqra9sf3lzgpxwdr590npkt03vufty4pwuu205q03az' },
];

const processedTokenHoldings = rawTokenHoldingsData.map(token => ({
  ...token,
  numericAmount: parseAmount(token.amount),
}));

export const getTreasuryTotalValueUSD = async () => {
  try {
    const response = await fetch(ASTROLESCENT_API_URL);
    if (!response.ok) {
      throw new Error(`Failed to fetch token prices for getTreasuryTotalValueUSD. Status: ${response.status}`);
    }
    const allTokenDataResponse = await response.json();

    let currentTotalUSD = 0;
    processedTokenHoldings.forEach(asset => {
      if (asset.resourceAddress && asset.numericAmount > 0) {
        const tokenInfo = allTokenDataResponse[asset.resourceAddress];
        if (tokenInfo && typeof tokenInfo.tokenPriceUSD === 'number') {
          currentTotalUSD += tokenInfo.tokenPriceUSD * asset.numericAmount;
        } else {
          console.warn(`Price data not found or invalid for ${asset.name} (${asset.resourceAddress}) - Symbol: ${asset.symbol} in getTreasuryTotalValueUSD`);
        }
      } else if (!asset.resourceAddress && asset.numericAmount > 0) {
        console.warn(`Resource address not found for ${asset.name} (Symbol: ${asset.symbol}), cannot calculate value in getTreasuryTotalValueUSD.`);
      }
    });
    return currentTotalUSD;
  } catch (err) {
    console.error("Error in getTreasuryTotalValueUSD:", err);
    throw err; // Re-throw the error to be handled by the caller
  }
};

const TokenHoldings = ({ allApiTokenData, pricesLoading }) => {
  if (!rawTokenHoldingsData || rawTokenHoldingsData.length === 0) {
    return <p>Token holdings data is currently unavailable.</p>;
  }

  return (
    <div className="token-holdings-grid">
      {rawTokenHoldingsData.map((token, index) => {
        const tokenInfo = allApiTokenData && token.resourceAddress ? allApiTokenData[token.resourceAddress] : null;
        const tokenPriceUSD = tokenInfo ? tokenInfo.tokenPriceUSD : null;
        const numericAmount = processedTokenHoldings.find(pToken => pToken.symbol === token.symbol)?.numericAmount || 0;

        return (
          <TokenCard
            key={index}
            iconUrl={token.iconUrl}
            name={token.name}
            symbol={token.symbol}
            amount={token.amount}
            numericAmount={numericAmount}
            tokenPriceUSD={tokenPriceUSD}
            isLoadingPrice={pricesLoading}
          />
        );
      })}
    </div>
  );
};
// End of Content from TokenHoldings.js


// Content from TreasuryUpdates.js (including UpdateCard)
const UpdateCard = ({ update }) => {
  const { text } = update;

  const linkifyText = (inputText) => {
    let linkedText = inputText;
    const urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    linkedText = linkedText.replace(urlPattern, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
    linkedText = linkedText.replace(/REDDICKS\.MEME/g, '<span class="highlight-text">REDDICKS.MEME</span>');
    return { __html: linkedText };
  };

  return (
    <div className="update-card">
      <div className="update-header">
        <span className="update-user">By: <strong>Gary</strong></span>
        <span className="official-badge">Official Note</span>
      </div>
      <div className="update-body" dangerouslySetInnerHTML={linkifyText(text)} />
    </div>
  );
};

const rawUpdatesData = [
  { user: "Gary", source: "rlyDev", text: "REDDICKS Treasury has just purchased: 1,000,000 XRD worth of Ecosystem tokens! We view this as an outstanding buying opportunity where many of these tokens are being dumped in fear due to the recent HUG Rug Pull. We have purchased the following in support of these projects!: .524 FLOOP, 200K DFP2, 145K MOX, 120K FOMO, 12K CVX, 20K ASTRL, 130K SRG, 13.6M MXRD, 2M DELIVER, 5M WOWO, 1.11M EARLY, 15B HIT, 50B CHUG! We also sold all the HUG and got 88,663 more XRD to replace it." },
  { user: "reddicks.xrd", source: "rlyDev", text: "REDDICKS has just purchased 5,000,000 DELIVER! We recognize that this project is undervalued currently and are happy to add more to our treasury at this time. Deliver is an outstanding project and these coins will be paired to REDDICKS and added as liquidity to further increase the liquidity of both projects! Join us! https://t.me/RedDicks_XRD and https://t.me/DELIVER_XRD" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "16hr ago", text: "REDDICKS TREASURY UPDATE! Holdings: 88,09­8,524 REDDICKS, 10.457M MXRD, 50.90B CHUG, 106.877M GOD, 3.888M EARLY, 35M DELIVER, 295.68M RUN FLY, 1.476 FLOOP, 208.176M HUG, 14.709M WOWO, 40M GREAT, and 97,746 XRD. We divested 50B CHUG for 45,842 XRD and ALL ZOOMIES for 27,914 XRD which are included. Some of our Run Fly was also set aside for promo­tions which is why it is less than before. We have also set aside 20% of the treasury purchases ($3,655 so far) which will be going to support freeing people from human traff­icking. We have so far used 12,00­0,000 REDDICKS from the initial 100M allocated to the treasury. These were used for liqui­dity, promo­tions, and of course treasury purch­ases. We have not redeemed any Oci fees since the last update." },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "5w ago", text: "REDDICKS validator has been launched! validator_rdx1swywqhv3ed5w6dldfs2vamtrsyrdsfd6l9cqen5xqe54597gyckpns Stake your XRD to the REDDICKS validator to earn the standard staking rate + 15% paid out in REDDICKS each month (For example: Current rate is 6.29% APY for XRD. You receive 6.29% + 15% addit­ional, earning 7.23% APY)! Payments to be made from the treasury on the first Monday of each month. Here is how this works: REDDI­CKS.XRD has staked 15M XRD to the validator (these XRD are not part of the treas­ury), these XRD are going to stay on the REDDICKS validator staking indef­initely and will be used as the source of funding for the addit­ional APY given. The validator fee is set to 100%. All validator fees taken in are going to the REDDICKS treasury to be used to buy REDDICKS. This will be an addit­ional source of consi­stent buying pressure for REDDICKS!.........." },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "5w ago", text: "PROOF OF $DCKS REDDICKS Staking is now LIVE! Stake your REDDICKS HERE: https://radix.defiplaza.net/token/resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp/staking and earn your share of 69 x 100 (6,900) REDDICKS per day paid out as 48,300 REDDICKS weekly each Monday! The first payout of 48,300 REDDICKS is on the 14th of this month and then it will be every Monday after that!" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "6w ago", text: "REDDICKS HAS THREE MAJOR ANNOU­NCMENTS: 1. We have deter­mined it is safe enough to extend the LP lock at C9. The 6 month initial lock has been extended 1 FULL YEAR starting today. Unlock would be 31 Mar 2026, but we plan to extend it again before unlock if safe to do so and keep this fully locked for 10 Entire Years! This would be all the way until 16 FEB 2035!! 2. REDDICKS is launching a valid­ator! Users who stake XRD to the validator will receive rewards in REDDICKS! The validator will roll out fully next week! 3. REDDICKS is launching REDDICKS staking through Defi Plaza and event­ually our website REDDI­CKS.MEME in conne­ction with Defi Plaza. Users will be able to stake their REDDICKS and receive an APY in REDDICKS for doing so. Staking will also roll out fully next week! We said we were going to re-lock and we are making good on that! We appre­ciate the incre­dible support we have received since our launch and are moving forward swiftly to bring the REDDICKS vision to life! Time for the MOON? See REDDI­CKS.MEME .........." },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "6w ago", text: "REDDICKS has added 9.8M WOWO and 106.199M GOD (GodF­ather) to the REDDICKS Treasury! We have also started building our website REDDI­CKS.MEME which will launch in Q2!" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "7w ago", text: "Lockups are reducing the REDDICKS market cap and visib­ility. In light of this, and because we now have a REDDICKS Treasury, we have decided to take the OCI pool fees and instead of forever locking them we are adding them to the Treasury each month. This first deposit of OCI fees into the REDDICKS Treasury is 23,990 XRD and 98,524 REDDICKS! We have also made two addit­ional Treasury additions since our last update: We added 200,0­44,550 HUG and 517,4­72,220 RUN FLY!" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "8w ago", text: "We are pleased to announce that REDDICKS has created the REDDICKS Treasury! So far the Treasury contains: 10M MXRD from we are Monstas, 148,411 ZOOMIES from Zoomies Labs, 1.47609 FLOOP from C9, 3.7076M EARLY, and 30.04M DELIVER. Any other funds that are added to the treasury will be posted in a once per month update. The treasury is going to be used to fund REDDICKS activity in the future and currently is being used to bootstrap addit­ional liquidity for REDDICKS. It is here to provide funding for the growth of REDDICKS and will always be used in that capacity. The treasury is currently contr­olled by REDDI­CKS.XRD where the rly.fun founders badge also sits. Control of these may be handed to the wider community in the future via a DAO or some other structure depending on what is decided. .........." },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "11w ago", text: "All fees redeemed from the OCI pool (the one with the liquidity perma­nently locked after gradu­ating from RLY.FUN) will be Forever Locked once redeemed. This will be done appro­ximately once per month. The first lock has just taken place! 2,296,722 REDDICKS were Forever Locked!!" },
  { user: "hairyotter.xrd", source: "hairyotter.xrd", timeAgo: "11w ago", text: "rly.fun" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "12w ago", text: "The C9 liquidity pool has been locked for 6 months! @ unlock it will it will be locked again!!" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "12w ago", text: "400,0­00,000 REDDICKS HAVE just been added to the C9 liquidity pool! The LP will be locked shortly. Trading fees have been set to .05% ---> This is 1/20th the cost of the starting OCI pool. Starting Liquidity at C9 was $466,000! OCI was $35,000 at the time so total starting is a cum squirt over $500,000 Everyone. This makes REDDICKS THE MOST LIQUID MEME COIN ON REDDICKS BY A LONG DONG!" },
  { user: "reddicks.xrd", source: "rlyDev", timeAgo: "12w ago", text: "400,0­00,000 REDDICKS Have just been locked for 69 years!" }
];

const UPDATES_TO_SHOW_INITIALLY = 3;

const TreasuryUpdates = () => {
  const [showAllUpdates, setShowAllUpdates] = useState(false);

  const updatesToDisplay = showAllUpdates ? rawUpdatesData : rawUpdatesData.slice(0, UPDATES_TO_SHOW_INITIALLY);

  const toggleShowAllUpdates = () => {
    setShowAllUpdates(!showAllUpdates);
  };

  return (
    <div className="updates-list-container">
      <div className="updates-list">
        {updatesToDisplay.map((update, index) => (
          <UpdateCard key={index} update={update} />
        ))}
        {rawUpdatesData.length === 0 && (
          <p>No treasury updates available at the moment.</p>
        )}
      </div>
      {rawUpdatesData.length > UPDATES_TO_SHOW_INITIALLY && (
        <button onClick={toggleShowAllUpdates} className="show-more-button">
          {showAllUpdates ? 'Show Less Updates' : 'Show More Updates'}
        </button>
      )}
    </div>
  );
};
// End of Content from TreasuryUpdates.js


const TreasuryPage = () => {
  const [totalValueUSD, setTotalValueUSD] = useState(0);
  const [loadingTotalValue, setLoadingTotalValue] = useState(true);
  const [errorTotalValue, setErrorTotalValue] = useState(null);
  const [allApiTokenData, setAllApiTokenData] = useState(null);
  const treasuryExplanationRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation(); // Get location object to access hash

  useEffect(() => {
    // Remove window.scrollTo as it's now handled globally by ScrollToTop
    document.body.style.overflow = 'auto';

    // Add hash fragment navigation handler
    const handleHashNavigation = () => {
      if (location.hash) {
        const id = location.hash.substring(1); // Remove the # character
        const element = document.getElementById(id);
        if (element) {
          // Allow a short delay for the page to render completely
          setTimeout(() => {
            element.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }
      }
    };

    // Call the navigation handler
    handleHashNavigation();

    const fetchTreasuryValue = async () => {
      setLoadingTotalValue(true);
      setErrorTotalValue(null);
      try {
        const response = await fetch(ASTROLESCENT_API_URL);
        if (!response.ok) {
          throw new Error(`Failed to fetch token prices. Status: ${response.status}`);
        }
        const allTokenDataResponse = await response.json();
        setAllApiTokenData(allTokenDataResponse);

        let currentTotalUSD = 0;
        processedTokenHoldings.forEach(asset => { // processedTokenHoldings is now locally defined
          if (asset.resourceAddress && asset.numericAmount > 0) {
            const tokenInfo = allTokenDataResponse[asset.resourceAddress];
            if (tokenInfo && typeof tokenInfo.tokenPriceUSD === 'number') {
              currentTotalUSD += tokenInfo.tokenPriceUSD * asset.numericAmount;
            } else {
              console.warn(`Price data not found or invalid for ${asset.name} (${asset.resourceAddress}) - Symbol: ${asset.symbol}`);
            }
          } else if (!asset.resourceAddress && asset.numericAmount > 0) {
            console.warn(`Resource address not found for ${asset.name} (Symbol: ${asset.symbol}), cannot calculate value.`);
          }
        });

        setTotalValueUSD(currentTotalUSD);
      } catch (err) {
        console.error("Error fetching treasury value:", err);
        setErrorTotalValue(err.message || 'Failed to calculate treasury value.');
      } finally {
        setLoadingTotalValue(false);
      }
    };

    fetchTreasuryValue();

    // Animation observer
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, { threshold: 0.1 });
    
    if (treasuryExplanationRef.current) {
      observer.observe(treasuryExplanationRef.current);
    }

    return () => {
      document.body.style.overflow = '';
      if (treasuryExplanationRef.current) {
        observer.unobserve(treasuryExplanationRef.current);
      }
    };
  }, [location]); // Add location dependency to re-run when URL changes

  return (
    <div className="treasury-page">
      <Header />
      <main className="treasury-content">
        {/* Hero Section */}
        <section className="treasury-hero-section">
          <div className="container">
            <h1>Inside the Reddicks Vault</h1>
            <p className="subtitle">Discover how we're strategically investing in Radix projects, supporting the community, and growing our collective D*CKStiny.</p>
            
            <div className="treasury-total-value-card">
              <div className="shine"></div>
              <h4>Total Treasury Value</h4>
              {loadingTotalValue && <p className="loading-message">Loading value...</p>}
              {errorTotalValue && <p className="error-message">Error: {errorTotalValue}</p>}
              {!loadingTotalValue && !errorTotalValue && (
                <div className="total-value">
                  {formatCurrency(totalValueUSD)}
                </div>
              )}
              <p className="data-source">
                Powered by <a href="https://astrl.trade/" target="_blank" rel="noopener noreferrer">Astrolescent API</a>.
              </p>
               {processedTokenHoldings.some(asset => !asset.resourceAddress && asset.numericAmount > 0) && (
                <p className="important-notice">
                  <strong>Note:</strong> Some token values could not be calculated due to missing resource addresses in the configuration. Check console for details.
                </p>
              )}
            </div>
          </div>
        </section>

        <section className="token-holdings-section" id="vault-holdings">
          <div className="container">
            <h2 className="section-title">Vault Holdings</h2>
            <TokenHoldings // Now using the local TokenHoldings component
              allApiTokenData={allApiTokenData} 
              pricesLoading={loadingTotalValue} 
            />
          </div>
        </section>

        <section className="treasury-explanation-section" ref={treasuryExplanationRef}>
          <div className="container">
            <h2 className={`section-title fade-in-title ${isVisible ? 'visible' : ''}`}>What is the Reddicks Treasury?</h2>
            
            <p className={`fade-in-text ${isVisible ? 'visible' : ''}`} style={{ transitionDelay: '0.2s' }}>
              The Reddicks Treasury functions as our community's dedicated resource hub, primed to catalyze growth across the Radix landscape. Our approach is hands-on: we thoughtfully acquire distinctive community tokens and NFTs, direct capital to enhance liquidity where it can make the most impact, and function as a supportive pillar for other notable Radix initiatives. Their advancement directly contributes to the prosperity of Radix as a whole, a principle that fuels our commitment.
            </p>
            
            <p className={`fade-in-text ${isVisible ? 'visible' : ''}`} style={{ transitionDelay: '0.4s' }}>
              Our singular aim is to see Radix flourish and establish its preeminence. Holding REDDICKS signifies direct involvement in this endeavor. As the REDDICKS token strengthens, our Treasury gains enhanced capacity to champion pioneering Radix concepts, contribute to seamless on-network exchange, and provide foundational support for emerging ventures. Beyond this, we are dedicated to creating wider impact: a considerable <span className="highlight-number">20%</span> of all Treasury receipts are channeled towards charitable work, with an initial focus on entities tackling human trafficking. In this way, our achievements ripple outwards, contributing to a greater good.
            </p>
            
            <p className={`fade-in-text ${isVisible ? 'visible' : ''}`} style={{ transitionDelay: '0.6s' }}>
              This Treasury is far more than a simple accumulation of digital assets; it's the very lifeblood of REDDICKS, conscientiously reinvesting into the Radix environment we passionately support. We believe fervently in Radix and its paradigm-shifting technology, and our Treasury stands as tangible proof of this conviction. If you're keen to explore the underpinnings of REDDICKS and our vision, we encourage you to <Link to="/whyreddicks" className="learn-more-link animated-link">Discover the Reddicks Difference!</Link>
            </p>
          </div>
        </section>

        <section className="treasury-updates-section" id="treasury-chronicle">
          <div className="container">
            <h2 className="section-title">Treasury Chronicle</h2>
            <TreasuryUpdates /> 
          </div>
        </section>

      </main>
      <Footer />
      <TelegramPopup />
    </div>
  );
};

export default TreasuryPage; 